var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "#202635"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.10899 6.54601C5 6.75992 5 7.03995 5 7.6V10.4C5 10.9601 5 11.2401 5.10899 11.454C5.20487 11.6422 5.35785 11.7951 5.54601 11.891C5.75992 12 6.03995 12 6.6 12H9.4C9.96005 12 10.2401 12 10.454 11.891C10.6422 11.7951 10.7951 11.6422 10.891 11.454C11 11.2401 11 10.9601 11 10.4V7.6C11 7.03995 11 6.75992 10.891 6.54601C10.7951 6.35785 10.6422 6.20487 10.454 6.10899C10.2401 6 9.96005 6 9.4 6H6.6C6.03995 6 5.75992 6 5.54601 6.10899C5.35785 6.20487 5.20487 6.35785 5.10899 6.54601ZM9 9C9 9.37014 8.7989 9.69331 8.5 9.86622V11H7.5V9.86622C7.2011 9.69331 7 9.37014 7 9C7 8.44772 7.44772 8 8 8C8.55228 8 9 8.44772 9 9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10V5C9.5 4.17157 8.82843 3.5 8 3.5V3.5C7.17157 3.5 6.5 4.17157 6.5 5V10",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.5351deb1.svg";
export { ForwardRef as ReactComponent };